// extracted by mini-css-extract-plugin
export var body = "_ic-0";
export var sectionHeader = "_ic-4";
export var shortcutColumns = "_ic-2";
export var shortcutList = "_ic-1";
export var shortcutSection = "_ic-3";